import { DataNotFound } from "../../../Components/SharedComponent/ReviewSummarySectionNotFound/DataNotFound";
import { toTitleCase } from "../../../Utils/stringUtls";
import {
  consumerChannel,
  merchantChannel,
  credit_merchantChannel,
  credit_consumerChannel,
  otherChannel,
  credit_otherChannel,
} from "../Channels/IndexContent";

const Channels = ({ data, formType }) => {
  if (!data) return <DataNotFound />;
  if (formType == 2) {
    var consumerChannelData = credit_consumerChannel;
    var merchantChannelData = credit_merchantChannel;
    var otherChannelData = credit_otherChannel;
    var consumerChannelOther = 6;
    var merchantOther = 1;
    var otherOther = 2;
  } else {
    var consumerChannelData = consumerChannel;
    var merchantChannelData = merchantChannel;
    var otherChannelData = otherChannel;
    var consumerChannelOther = 6;
    var merchantOther = 2;
    var otherOther = 3;
  }
  const {
    c_gi_consumer_channels,
    c_gi_consumer_channel_other,
    c_gi_stakeholder_channels,
    c_gi_stakeholder_channel_other,
    c_gi_other_channels,
    c_gi_other_channel_other,
  } = data["4_0"];
  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid gap-sm" className="">
        <div i2c-grid="12@md">
          <div className="font-bold overview-help-text">
            Cardholder/Consumer Channels
          </div>
          <div
            className="overview-val-text"
            style={{
              display: "flex",
              gap: "var(--i2c-spacing-3)",
              flexWrap: "wrap",
            }}
          >
            {c_gi_consumer_channels?.length
              ? consumerChannelData.map((network, index) =>
                  c_gi_consumer_channels?.includes(network.value) ? (
                    <li
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "var(--i2c-spacing-2)",
                      }}
                      key={index}
                    >
                      <span>
                        {network.value === consumerChannelOther
                          ? toTitleCase(c_gi_consumer_channel_other)
                          : network.label}
                        ,
                      </span>
                      {/* {c_gi_consumer_channels?.length > index ? ", " : ""} */}
                    </li>
                  ) : (
                    ""
                  ),
                )
              : "-"}
          </div>
        </div>
        <div i2c-grid="12@md">
          <div className="font-bold overview-help-text">
            Merchant/Stakeholder Channels
          </div>
          <div
            className="overview-val-text"
            style={{
              display: "flex",
              gap: "var(--i2c-spacing-3)",
              flexWrap: "wrap",
            }}
          >
            {c_gi_stakeholder_channels?.length
              ? merchantChannelData.map((network, index) =>
                  c_gi_stakeholder_channels?.includes(network.value) ? (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "var(--i2c-spacing-2)",
                      }}
                      key={index}
                    >
                      <span>
                        {network.value === merchantOther
                          ? toTitleCase(c_gi_stakeholder_channel_other)
                          : network.label}
                        ,
                      </span>
                      {/* {c_gi_stakeholder_channels?.length > index ? ", " : ""} */}
                    </span>
                  ) : (
                    ""
                  ),
                )
              : "-"}
          </div>
        </div>
        <div i2c-grid="12@md">
          <div className="font-bold overview-help-text">Other Channels</div>
          <div
            className="overview-val-text"
            style={{
              display: "flex",
              gap: "var(--i2c-spacing-3)",
              flexWrap: "wrap",
            }}
          >
            {c_gi_other_channels?.length
              ? otherChannelData.map((network, index) =>
                  c_gi_other_channels?.includes(network.value) ? (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "var(--i2c-spacing-2)",
                      }}
                      key={index}
                    >
                      <span>
                        {network.value === otherOther
                          ? toTitleCase(c_gi_other_channel_other)
                          : network.label}
                        ,
                      </span>
                      {/* {c_gi_other_channels?.length > index ? ", " : ""} */}
                    </span>
                  ) : (
                    ""
                  ),
                )
              : "-"}
          </div>
        </div>
      </div>
    </div>
  );
};
export default Channels;
